var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "w-row",
    [
      _c(
        "w-col",
        { attrs: { xs: "12", lg: "12", grow: "" } },
        [
          _c(
            "w-card",
            { style: { flexGrow: 1 } },
            [
              _c("w-card-title", [_vm._v(_vm._s(_vm.$ct("title-fields")))]),
              _c(
                "w-card-content",
                [
                  _vm.isAllowed(27)
                    ? _c("app-extra-fields-edit", {
                        attrs: {
                          value: _vm.product.ExtraFields,
                          "name-settings": _vm.extraFieldNameSettings,
                          "tab-id": "",
                        },
                      })
                    : _c(
                        "w-row",
                        [
                          _c("app-missing-module", {
                            attrs: { "module-id": 27 },
                          }),
                        ],
                        1
                      ),
                ],
                1
              ),
            ],
            1
          ),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }